import { cancellableRequest } from './request';

const ProfileService = {
    // replace it with a service like 'getProfile'
    getProfile: () => cancellableRequest({ method: 'get', url: '/transfer/customer', params: { pageSize: 1 } }),
};

export { ProfileService };
